<template>
  <transition name="s_popup_transition">
    <div class="popup" v-if="show">
        <div class="popup-inner" v-on-clickaway='() => onChange(false)' :class="{'popup-height-100': type === 'history'}">
            <a href="#" class="close" @click="onChange(false)"></a>
            <!-- <div class="left">
                <div class="left-wrap">
                    <div class="popup-menu">
                        <a href="#" :class="{'act': type === 'profile' ||  type === 'profile-edit'}" @click.prevent="onChange('profile')">Personal data</a>
                        <a href="#" :class="{'act': type === 'channels'}" @click.prevent="onChange('channels')">Communication channels</a>
                        <a href="#" :class="{'act': type === 'favorites'}" @click.prevent="onChange('favorites')">Favorites</a>
                        <a href="#" :class="{'act': type === 'history'}" @click.prevent="onChange('history')">History</a>
                    </div>
                    <a v-if="remoteConfig && remoteConfig.logoutLink" :href="remoteConfig.logoutLink" class="exit-btn">Exit</a>
                </div>
                <div class="banner">
                  <a :href="remoteConfig.bannerLink || '#'">
                    <img :src="remoteConfig.bannerImage">
                  </a>
                </div>
            </div> -->

            <app-popup-profile v-if="type === 'profile' || type === 'profile-edit'" :type="type" @onChange="type = $event" />
            <app-popup-channels v-if="type === 'channels'" />
            <app-popup-favorites v-if="type === 'favorites'" />
            <app-popup-history v-if="type === 'history'" />

        </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import AppPopupProfile from "./AppPopupProfile";
import AppPopupHistory from "./AppPopupHistory";
import { directive as onClickaway } from "vue-clickaway2";
export default {
  name: "AppPopup",
  components: {
    AppPopupProfile,
    AppPopupHistory
  },
  "directives": {
      onClickaway
  },
  data() {
    return {
      show: false,
      type: null
    };
  },
  watch: {
    show(value) {
      let className = 'lock-scroll';
      if(value) {
        document.getElementsByTagName("body")[0].style.top = -(document.documentElement.scrollTop) + 'px'
        document.documentElement.classList.add(className);
      } else {
        document.documentElement.classList.remove(className);
        document.documentElement.scrollTop = -parseFloat(document.getElementsByTagName("body")[0].style.top.replace("px",''))
      }
    }
  },
  computed: {
    ...mapGetters(["remoteConfig"]),
    bannerStyles() {
      return this.remoteConfig && this.remoteConfig.bannerImage
        ? { "background-image": "url(" + this.remoteConfig.bannerImage + ")" }
        : {};
    }
  },
  methods: {
    onChange(value) {
      this.show = !!value;
      this.type = value;
    }
  },
  beforeMount() {
    this.$eventBus.$on("popup", this.onChange);
  },
  beforeDestroy() {
    this.$eventBus.$off("popup", this.onChange);
  }
};
</script>
